module.exports = __webpack_public_path__ + "static/media/bu-actual.c7da584b.svg";